import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { IExam, IExaminationExaminer, IExamQuestions } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-examiners',
  templateUrl: './exam-examiners.component.html',
  styleUrls: ['./exam-examiners.component.scss']
})
export class ExamExaminersComponent implements OnInit {
  exam: IExam = examDefault;

  examinationExaminer: IExaminationExaminer = {
    examinationID: 0,
    user: '',
    id: 0
  }
  users: any[] = [];
  constructor(private examService: ExamService, private snackBar: SnackbarService, private evnt: EventService,) { }

  ngOnInit() {
    GridUtil.setClearGridSelection();
    this.exam = this.examService.selectedExams[0];
    this.evnt.addExaminerMessageEvent.subscribe((message: any) => {
      this.refreshData(this.data.tableParams);
    })
    this.refreshData(this.data.tableParams);
  }

  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Examination ID',
      fieldName: 'examinationID',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Username',
      fieldName: 'user',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
  ];
  updateGridParams(res: any) {
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1, res.length));
  }

  async refreshData(tableParams) {
    tableParams.ExaminationID = this.exam.id;
    const res = await this.examService.getExaminationExaminerTable(tableParams) as any[];
    this.updateGridParams(res);
  }
  emitExaminerData(Ids: any[]) {
    const examinerList: any[] = [];
    Ids.forEach(x => examinerList.push(this.data.tableRows[x]));
    this.examinationExaminer = examinerList[0];
    let selectedDataRowsId = examinerList.map(x => x.id);
    GridUtil.setRowCliclk("examExaminerGrid", Ids, selectedDataRowsId);
  }


  removeExaminer() {
    this.examService.deleteExaminationExaminer(this.examinationExaminer).then(async s => {
      await this.refreshData(this.data.tableParams);
      this.snackBar.success('Examiner deleted successfully!!');
    });
  }


}
